/*
 * @Author: cryi.liu
 * @Date: 2020-05-11 16:16:48
 * @LastEditTime: 2020-06-15 14:11:20
 * @Description: write you description
 */
import AuthService from './services/auth.service';
import ExamcenterService from './services/examcenter.service';
import AnswerService from './services/answerService';

class Http {
  constructor() {
    this.auth = new AuthService();
    this.examcenter = new ExamcenterService();
    this.answer = new AnswerService();
  }
}

const http = new Http();

export default http;
